module.exports = __webpack_public_path__ + "static/media/feather.236fad3a.svg";